/**
 * Type definitions for cache utility functions
 */

import { NotificationPlacement } from 'antd/es/notification/interface';
import { TransportStationPlaceType } from 'app/modules/Trip/Overview/Transport/types';
/**
 * Generic object type that can hold any key-value pairs
 */
export type GenericObject = { [key: string]: any };

/**
 * Type for data that can be stored in localStorage
 * Can be either a string or a generic object
 */
export type StorageData = string | GenericObject;

/**
 * Type for data with expiry information
 */
export interface ExpiryData<T> {
  data: T;
  expiresAt: Date;
}

/**
 * Type for response from getFromLocalWithExpiry function
 */
export interface ExpiryResponse<T> {
  isExpired: boolean;
  data: T | null;
}

export interface NotificationPropsInterface {
  showProgress?: boolean;
  pauseOnHover?: boolean;
  placement?: NotificationPlacement;
}

export const NotificationProps: NotificationPropsInterface = {
  showProgress: true,
  pauseOnHover: true,
  placement: 'topRight',
};

interface AddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}

interface Geometry {
  location: {
    lat: () => number;
    lng: () => number;
  };
}

export interface GooglePlaceApiResponse {
  address_components: AddressComponent[];
  formatted_address: string;
  geometry: Geometry;
  place_id: string;
  html_attributions: string[];
}

export enum MobilityPlaceType {
  CAR_RENTAL = 'CAR_RENTAL',
  PASSENGER_ADDRESS = 'PASSENGER_ADDRESS',
}

export interface AddressOutput {
  cityId: number;
  name: string | null;
  googlePlaceId: string | null;
  placeType: MobilityPlaceType | TransportStationPlaceType | null;
  cityName: string;
  country: string | null;
  countryCode: string | null;
  state: string | null;
  formattedAddress: string | null;
  street: string | null;
  number: string | null;
  complement: string | null;
  district: string | null;
  zipCode: string | null;
  latitude: number | null;
  longitude: number | null;
}

// Custom validation context for our validation functions
export interface DepartureArrivalValidationContext {
  getFieldValue: (name: string) => unknown;
  t: (key: string) => string;
}
